export class InsuranceSumAndPremium {
    constructor(public data: {
        insuranceStart?: String,
        insuranceEnd?: String,
        insurancePeriod?: Number,
        accessAge?: Number,
        gender?: String,
        occupation?: String,
        dynamicsOfPayment?: String,
        cigarettesDaily?: Number,
        height?: Number,
        weight?: Number,
        currencyPayment?: String,
        currencyPayout?: String,
        indexation?: String,
        methodPayment?: String
    }) { }
}